import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { FormControl } from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Option } from '@vi-iot/ui/components/dropdown-autocomplete/dropdown-autocomplete.component';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'vi-dropdown-autocomplete-multiselect',
  templateUrl: './dropdown-autocomplete-multiselect.component.html',
  styleUrls: ['./dropdown-autocomplete-multiselect.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViDropdownAutocompleteMultiselectComponent implements OnInit {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  formControl = new FormControl<string | undefined>(undefined);
  autocompleteHeight = '320px';

  @Input() placeholder = '';
  @Input() options: Option[];
  @Input() width = '100%';
  @Input() disabled = false;
  @Input() elementHeight: number = 25;
  @Input() unselectMessageKey?: string;

  @Output() optionChange: EventEmitter<Option[]> = new EventEmitter<Option[]>();

  @ViewChild(CdkVirtualScrollViewport) virtualScroll: CdkVirtualScrollViewport;
  filterString = '';
  selectData: Option[] = [];
  filteredData: Observable<Array<Option>>;

  constructor() {
    this.filteredData = this.formControl.valueChanges.pipe(
      startWith<string>(''),
      map((value) => (typeof value === 'string' ? value : this.filterString)),
      map((filter) => this.filter(filter))
    );
  }

  ngOnInit(): void {
    this.autocompleteHeight = `${Math.min(this.options.length * 80, 320)}px`;
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  unselectAll(): void {
    this.options.forEach((option) => (option.selected = false));
    this.selectData = [];
    this.optionChange.emit(this.selectData);
  }

  optionClicked(event: Event, selectedItem: Option): void {
    event.stopPropagation();
    this.toggleSelection(selectedItem);
  }

  toggleSelection(selectedItem: Option): void {
    selectedItem.selected = !selectedItem.selected;
    if (selectedItem.selected === true) {
      this.selectData.push(selectedItem);
    } else {
      const i = this.selectData.findIndex((item) => item.value === selectedItem.value);
      this.selectData.splice(i, 1);
    }
    this.optionChange.emit(this.selectData);
  }

  autocompleteValuesTrackBy(_index: number, option: Option): string {
    return option?.value;
  }

  onDropdownOpen() {
    this.virtualScroll.scrollToIndex(0);
    this.virtualScroll.checkViewportSize();
  }

  private filter(filter: string): Array<Option> {
    this.filterString = filter;
    if (filter.length > 0) {
      return this.options.filter((option) => {
        return (
          option.value.toLowerCase().indexOf(filter.toLowerCase()) >= 0 ||
          option.viewValue.toLowerCase().indexOf(filter.toLowerCase()) >= 0 ||
          option.viewValueTwo?.toLowerCase().indexOf(filter.toLowerCase()) >= 0
        );
      });
    } else {
      return this.options.slice();
    }
  }
}
